<template>
	<div class="publicBox">
		<div class="main">
			<ul class="titleList flexBox">
				<li>我的合同</li>
			</ul>
		</div>

		<a-table class="publicTable" :columns="columns" :data-source="tableData" :rowKey="res => {return res.id}"
			:pagination="pageData" @change="changePage">
			<span slot="money" slot-scope="text" class="blue">{{ text }}</span>
			<div slot="operation" slot-scope="text,record" class="opera">
				<div class="item flexBox" @click="clickDown(record)">
					<img src="../../../assets/img/admin/icon_5.png" class="icon">
					<span>下载</span>
				</div>
			</div>
		</a-table>
	</div>
</template>

<script>
	export default {
		name: 'Pact',
		components: {},
		data() {
			return {
				tableLoad: false,
				tableData: [],
				columns: [{
					title: '序号',
					dataIndex: 'id',
					scopedSlots: {
						customRender: 'id'
					},
					align: 'center',
					customRender: (text, record, index) => {
						return (this.pageData.current - 1) * this.pageData.pageSize + index + 1;
					}
				}, {
					title: '合同名称',
					dataIndex: 'contractName',
					scopedSlots: {
						customRender: 'contractName'
					},
					align: 'center'
				}, {
					title: '合同金额（元）',
					dataIndex: 'contractAmount',
					scopedSlots: {
						customRender: 'contractAmount'
					},
					align: 'center'
				}, {
					title: '合同上传日期',
					dataIndex: 'uploadTime',
					scopedSlots: {
						customRender: 'uploadTime'
					},
					align: 'center'
				}, {
					title: '操作',
					dataIndex: 'operation',
					scopedSlots: {
						customRender: 'operation'
					},
					fixed: 'right',
				}],
				pageData: {
					current: 1,
					pageSize: 10,
					total: 0,
					showLessItems: true,
					showTotal: total => `共 ${total} 条`
				},
			}
		},
		mounted() {
			this.getData()
		},
		methods: {
			getData(){
				this.$reqToken("get", "/api/center/contract/list",{
					pageNum: this.pageData.current,
					pageSize: this.pageData.pageSize,
				},true).then((res) => {
					this.updateTable(res);
				})
			},
			updateTable(data) {
				this.tableData = data.rows;
				this.pageData.total = data.total;
			},
			changePage(res){
				this.pageData.current = res.current;
				this.getData()
			},
			clickDown(res){
				window.open(res.contractFile,"_blank");
			}
		}
	}
</script>

<style scoped>
.opera {
	display: flex;
	align-items: center;
	gap: 10px;
}

</style>